import { gql, useQuery } from '@apollo/client';
import {
  BrandKey,
  GetPromptsQuery,
  GetPromptsQueryVariables,
} from '../../__generated__/queries-web';

const GET_PROMPTS = gql`
  query GetPrompts(
    $first: UnsignedInt!
    $where: PromptFilterInput
    $skip: UnsignedInt
  ) {
    prompts(first: $first, where: $where, skip: $skip) {
      field
      label
      body
      brandKey
    }
  }
`;

export const GET_PROMPT = gql`
  query GetPrompt(
    $brandKey: BrandKey!
    $field: PromptField!
    $label: NonEmptyTrimmedString!
  ) {
    prompt(where: { brandKey: $brandKey, field: $field, label: $label }) {
      body
    }
  }
`;

export const useGetBrandPrompts = (brandKey: BrandKey) =>
  useQuery<GetPromptsQuery, GetPromptsQueryVariables>(GET_PROMPTS, {
    variables: {
      first: 50,
      where: { brandKey },
    },
  });
